import { filterAndMap, typedEntries } from "../core/utils";

export interface EmbedParameters {
  mapboxToken?: string;
  configUrl?: string;
  csvUrl?: string;
  spreadsheet?: string;
  additionalCSS?: string;
}

const parameterMapping: Record<keyof EmbedParameters, string> = {
  mapboxToken: "mapbox-token",
  configUrl: "config",
  csvUrl: "csv",
  spreadsheet: "google-sheet",
  additionalCSS: "additional-css",
};

export default function useEmbedParameters(): EmbedParameters {
  const search = new URLSearchParams(window.location.search);

  return Object.fromEntries(
    Object.entries(parameterMapping).map(([key, name]) => [
      key,
      search.get(name) ?? undefined,
    ])
  );
}

export function embedParametersToURL(params: EmbedParameters): string {
  const search = filterAndMap(typedEntries(params), ([key, value]) =>
    value != null && value.length > 0
      ? `${parameterMapping[key]}=${encodeURIComponent(value)}`
      : null
  ).join("&");
  return `${window.location.protocol}//${window.location.host}${window.location.pathname}?${search}`;
}

export function embedParametersToHTML(params: EmbedParameters): string {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  return `<iframe
  title="Map Embed"
  data-map-embed="${baseUrl}"
  data-config="${params.configUrl}"
  data-mapbox-token="${params.mapboxToken}"${
    params.csvUrl != null && params.csvUrl.length > 0
      ? `
  data-csv="${params.csvUrl}"`
      : ""
  }${
    params.spreadsheet != null && params.spreadsheet.length > 0
      ? `
  data-google-sheet="${params.spreadsheet}"`
      : ""
  }
></iframe>
<script src="${baseUrl}/embed.js"></script>`;
}
